module.exports = __webpack_public_path__ + "img/59.2a5e1ac8.png";